import React from 'react';
import styles from './InitiativesList.module.scss';

import { IntersectionObserverClient } from '../../../../../IntersectionObserver';
import { ReportListItemFallback } from '../../../../../Components/ReportList/ReportListItemFallback/ReportListItemFallback';
import { InitiativeValue } from '../../../../../Models/InitiativeValue';
import { InitiativeCard } from './InitiativeCard/InitiativeCard';

export interface InitiativesListProps {
  initiatives: InitiativeValue[];
}

export const InitiativesList = ({
  initiatives
}: InitiativesListProps): React.ReactElement<InitiativesListProps> => {
  return (
    <div className={styles.initiativesList}>
      <div className={styles.content}>
        {initiatives &&
          initiatives.length > 0 &&
          initiatives.map((initiative: InitiativeValue) => (
            <IntersectionObserverClient
              key={initiative.id}
              fallback={<ReportListItemFallback />}
            >
              <InitiativeCard initiative={initiative} />
            </IntersectionObserverClient>
          ))}
      </div>
    </div>
  );
};
